module.exports = __webpack_public_path__ + "static/img/ent-detail-86.3751329.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-86.jpg
// module id = SDoI
// module chunks = 52